import artistSrc1 from './assets/Artist-01.jpg';
import artistSrc2 from './assets/Artist-02.jpg';
import artistSrc3 from './assets/Artist-03.jpg';
import artistSrc4 from './assets/Artist-04.jpg';
import artistSrc5 from './assets/Artist-05.jpg';
import artistSrc6 from './assets/Artist-06.jpg';
import artistSrc7 from './assets/Artist-07.jpg';
import artistSrc8 from './assets/Artist-08.jpg';
import artistSrc9 from './assets/Artist-09.jpg';
import artistSrc10 from './assets/Artist-10.jpg';
import artistSrc11 from './assets/Artist-11.jpg';
import artistSrc12 from './assets/Artist-12.jpg';
import artistSrc13 from './assets/Artist-13.jpg';
import artistSrc14 from './assets/Artist-14.jpg';
import artistSrc15 from './assets/Artist-15.jpg';
import artistSrc16 from './assets/Artist-16.jpg';
import artistSrc17 from './assets/Artist-17.jpg';
import artistSrc18 from './assets/Artist-18.jpg';
import artistSrc19 from './assets/Artist-19.jpg';

export const SCHWARZKOPF_ARTISTS = [
  {
    imageSrc: artistSrc1,
    brand: 'SCHWARZKOPF',
    name: 'Joey Marchese',
    role: 'PLATFORM ARTIST',
    socialHandle: '@joeymarchese',
    socialLink: 'https://www.instagram.com/joeymarchese',
    bio: 'Joev is a passionate platform artist with Schwarzkopf Professional, known for his innovative approach to cutting and styling. With years of experience in the industry, he brings creative energy and technical expertise to every class, inspiring stylists to push their boundaries and explore new techniques.',
  },
  {
    imageSrc: artistSrc2,
    brand: 'SCHWARZKOPF',
    name: 'Robin La Chance',
    role: 'PLATFORM ARTIST',
    socialHandle: '@robin_la_chance',
    socialLink: 'https://www.instagram.com/robin_la_chance',
    bio: 'Robin La Chance is a skilled platform artist who excels in color theory and advanced coloring techniques. Her passion for education and ability to break down complex concepts into easy-to-understand methods makes her classes both informative and engaging for stylists at all levels.',
  },
  {
    imageSrc: artistSrc3,
    brand: 'SCHWARZKOPF',
    name: 'Nicole Pede',
    role: 'PLATFORM ARTIST',
    socialHandle: '@nmpede',
    socialLink: 'https://www.instagram.com/nmpede',
    bio: 'Nicole is a dedicated platform artist who specializes in modern cutting techniques and precision styling. Her commitment to excellence and eye for detail have made her a sought-after educator, helping salon professionals elevate their craft and deliver exceptional results to their clients.',
  },
  {
    imageSrc: artistSrc4,
    brand: 'SCHWARZKOPF',
    name: 'Marek Whitechurch',
    role: 'PLATFORM ARTIST',
    socialHandle: '@marek_whitechurch_hairstylist',
    socialLink: 'https://www.instagram.com/marek_whitechurch_hairstylist',
    bio: 'Marek Whitechurch brings a unique blend of artistic vision and technical skill to his role as a platform artist. With extensive experience in both editorial and salon work, he shares practical insights and innovative techniques that help stylists stay ahead of industry trends.',
  },
  {
    imageSrc: artistSrc5,
    brand: 'SCHWARZKOPF',
    name: 'Mario Cicciarella',
    role: 'PLATFORM ARTIST',
    socialHandle: '@marcheech',
    socialLink: 'https://www.instagram.com/marcheech',
    bio: 'Mario is a versatile platform artist known for his expertise in both color and cutting. His dynamic teaching style and wealth of knowledge make his classes engaging and transformative, providing stylists with the tools they need to grow their skills and confidence.',
  },
  {
    imageSrc: artistSrc6,
    brand: 'SCHWARZKOPF',
    name: 'Mark Chamberlain',
    role: 'PLATFORM ARTIST',
    socialHandle: '@markchamberlain_hair',
    socialLink: 'https://www.instagram.com/markchamberlain_hair',
    bio: 'Mark Chamberlain is a renowned platform artist who excels in advanced cutting and styling techniques. His passion for the craft and dedication to education inspire stylists to refine their skills and deliver exceptional service in their salons.',
  },
  {
    imageSrc: artistSrc7,
    brand: 'SCHWARZKOPF',
    name: 'Katia Jananji',
    role: 'PLATFORM ARTIST',
    socialHandle: '@katiajananji',
    socialLink: 'https://www.instagram.com/katiajananji',
    bio: 'Katia is a talented platform artist specializing in color techniques and creative styling. Her warm approach to teaching and ability to connect with stylists makes her classes both educational and inspiring, helping professionals unlock their creative potential.',
  }
];

export const JOICO_ARTISTS = [
  {
    imageSrc: artistSrc8,
    brand: 'JOICO',
    name: 'Melissa Duguay',
    role: 'MASTER ARTIST',
    socialHandle: '@melzduguay',
    socialLink: 'https://www.instagram.com/melzduguay',
    bio: 'Melissa is a master artist with Joico, renowned for her expertise in color formulation and trend-setting techniques. Her dynamic teaching style and deep understanding of color science make her classes essential for stylists looking to master the art of color and deliver stunning results.',
  },
  {
    imageSrc: artistSrc9,
    brand: 'JOICO',
    name: 'Armineh Damanpak',
    role: 'ARTISTIC AMABASSADOR',
    socialHandle: '@hairbyarmineh',
    socialLink: 'https://www.instagram.com/hairbyarmineh',
    bio: 'Armineh is an artistic ambassador who brings passion and precision to every class. Her expertise in modern coloring techniques and balayage has made her a respected educator, helping stylists achieve beautiful, dimensional results that keep clients coming back.',
  },
  {
    imageSrc: artistSrc10,
    brand: 'JOICO',
    name: 'Lisa Schoor',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@lisaschoorhair',
    socialLink: 'https://www.instagram.com/lisaschoorhair',
    bio: 'Lisa is a dedicated artistic educator who specializes in blonding techniques and color correction. Her patient teaching approach and technical expertise help stylists build confidence in tackling even the most challenging color transformations.',
  },
  {
    imageSrc: artistSrc11,
    brand: 'JOICO',
    name: 'François Bouffard',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@francoisbouffard',
    socialLink: 'https://www.instagram.com/francoisbouffard',
    bio: 'François is a bilingual artistic educator known for his expertise in cutting and styling. His creative approach and ability to teach in both English and French makes his classes accessible and valuable for stylists across Canada.',
  },
  {
    imageSrc: artistSrc12,
    brand: 'JOICO',
    name: 'Daniela Ross',
    role: 'ARTIST',
    socialHandle: '@deelicioushair',
    socialLink: 'https://www.instagram.com/deelicioushair',
    bio: 'Daniela is a talented artist who excels in vivid color work and creative styling. Her enthusiasm for pushing creative boundaries and exploring new techniques inspires stylists to embrace their artistic side and offer unique services to their clients.',
  },
  {
    imageSrc: artistSrc13,
    brand: 'JOICO',
    name: 'Marc-André Poulin',
    role: 'ARTISTIC EDUCATOR',
    socialHandle: '@mapstylehair',
    socialLink: 'https://www.instagram.com/mapstylehair',
    bio: 'Marc-André is an artistic educator with a passion for men\'s grooming and precision cutting. His technical skill and modern approach to barbering techniques make his classes invaluable for stylists looking to expand their service offerings.',
  },
  // {
  //   imageSrc: artistSrc15,
  //   brand: 'JOICO',
  //   name: 'Jeannyfer Bernier',
  //   role: 'ARTISTIC EDUCATOR',
  //   socialHandle: '@stylist.jeanny',
  //   socialLink: 'https://www.instagram.com/stylist.jeanny',
  //   bio: 'Jeannyfer is a skilled artistic educator who specializes in contemporary color techniques and lived-in color. Her expertise in creating low-maintenance, beautiful results helps stylists meet the needs of today\'s busy clients.',
  // },
  // {
  //   imageSrc: artistSrc14,
  //   brand: 'JOICO',
  //   name: 'Staelle Coulombe',
  //   role: 'ARTISTIC EDUCATOR',
  //   socialHandle: '@Staellecolorful',
  //   socialLink: 'https://www.instagram.com/Staellecolorful',
  //   bio: 'Staelle is a creative artistic educator known for her bold use of color and innovative techniques. Her vibrant personality and passion for education make her classes engaging and memorable, helping stylists discover new ways to express creativity.',
  // },
];

export const STMNT_ARTISTS = [
  {
    imageSrc: artistSrc16,
    brand: 'STMNT',
    name: 'Paul Doyle',
    role: 'Ambassador - Montreal, QC',
    socialHandle: '@doylescuts',
    socialLink: 'https://www.instagram.com/doylescuts',
    bio: 'Paul Doyle is a dedicated bi-lingual Montreal-based barber and proud STMNT ambassador. With multiple barbering competition wins in Montreal and Toronto, he\'s recognized for both his precision and creativity. Specializing in classic cuts, contemporary fades, and intricate braiding, Paul combines technical skill with a genuine passion for the craft.',
  },
  {
    imageSrc: artistSrc19,
    brand: 'STMNT',
    name: 'Jordan Richards',
    role: 'Ambassador - Victoria, BC ',
    socialHandle: '@freeformbarber.studio',
    socialLink: 'https://www.instagram.com/freeformbarber.studio',
    bio: 'Jordan Richards (aka J.Fades) is the founder and owner of Free Form Barber Studio based out of Victoria BC. - With a passion for people & innovative barbering and hairstyling techniques, J.Fades has created a one stop shop for all your needs. J.Fades has created a combined atmosphere that offers a new take on classic barbering techniques turned  into modern hairstyling trends customized to each individual. Working with STMNT products gives J.fades the ability to transform the hair into something that stands outside the box bringing creativity to a new level.',
  },
  // {
  //   imageSrc: artistSrc17,
  //   brand: 'STMNT',
  //   name: 'Chris Venditti',
  //   role: 'ARTISTIC AMABASSADOR',
  //   socialHandle: '@chrisvenditti.hair',
  //   socialLink: 'https://www.instagram.com/chrisvenditti.hair',
  //   bio: 'Chris is an artistic ambassador with STMNT, bringing expertise in men\'s grooming and modern barbering techniques. His innovative approach to classic cuts and contemporary styling makes his classes essential for stylists looking to master the art of barbering.',
  // },
];

export const DEVACURL_ARTISTS = [
  {
    imageSrc: artistSrc18,
    brand: 'DEVACURL',
    name: 'Denise Hosni',
    role: 'Artist - Montreal, QC',
    socialHandle: '@denise.hosni',
    socialLink: 'https://www.instagram.com/denise.hosni',
    bio: 'Denise is a bilingual stylist-turned-educator who discovered a passion for curls early in her career. After extensive training, she became a DevaCurl Educator, helping stylists elevate their curl expertise. She brings skill and enthusiasm to every lesson, using the DevaCurl and DevaCut methods to inspire transformation, one curl at a time.',
  },
];

export const artists = [
  ...SCHWARZKOPF_ARTISTS,
  ...JOICO_ARTISTS,
  ...STMNT_ARTISTS,
  ...DEVACURL_ARTISTS,
];
